// @flow
import * as React from 'react';
import { useInterval } from '../../hooks';
import { SessionExpiredDisplay } from './SessionExpiredDisplay';

const SessionExpiredPage = () => {
  const [seconds, setSeconds] = React.useState<number>(5);

  React.useEffect(() => {
    if (seconds === 0) {
      window.location.href = window.origin;
    }
  }, [seconds]);

  useInterval(() => {
    setSeconds(Math.max(0, seconds - 1));
  }, 1000);

  return <SessionExpiredDisplay seconds={seconds} />;
};

export default SessionExpiredPage;
